import React from "react"
import * as sectionStyle from "../section.module.css"
import * as style from "./blocks.module.css"
import { chainList1, chainList2 } from "../chains.js"
import { Trans, useTranslation } from "gatsby-plugin-react-i18next"

export function Blocks() {
  const { t } = useTranslation()
  return (
    <section className={sectionStyle.section}>
      <h2 className={sectionStyle.sectionHeader}>
        <Trans>intro</Trans>
      </h2>
      <p className={sectionStyle.sectionContent}>
        <Trans>start</Trans>
      </p>
      <ul className={`${style.blockList} ${style.moveLeft}`}>
        {chainList1.map(chain => {
          return (
            <li key={chain.key}>
              <a href={chain.link} rel="noreferrer" target="_blank">
                <div className={style.block}>
                  {chain.img}
                  <span>{chain.name}</span>
                </div>
              </a>
            </li>
          )
        })}
      </ul>
      <ul className={`${style.blockList} ${style.moveRight}`}>
        {chainList2.map(chain => {
          return (
            <li key={chain.key}>
              <a href={chain.link} rel="noreferrer" target="_blank">
                <div className={style.block}>
                  {chain.img}
                  <span>{chain.name}</span>
                </div>
              </a>
            </li>
          )
        })}
      </ul>
      <div className={style.tryParent}>
        <a
          className={style.btn}
          href={t("try.url")}
        >
          <Trans>try</Trans>
        </a>
      </div>
    </section>
  )
}
